import React from 'react';

import Card from '@/ui/components/Card';
import Heading from '@/ui/components/Heading';

import { Props } from './types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const CenteredCardPage = ({ heading, message }: Props) => {
  return (
    <div className="flex items-center justify-center min-h-[60vh] px-4">
      <Card className="bg-neutral-primary-soft block max-w-sm p-6 border border-default rounded-base shadow-xs">
        <Heading level={1}>{heading}</Heading>
        <p className="mt-4 text-neutral-primary-base">{message}</p>
      </Card>
    </div>
  );
};
export default React.memo(CenteredCardPage);
